import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DeleteRecurringFeeMutationVariables = Types.Exact<{
  email: Types.Scalars["String"];
}>;

export type DeleteRecurringFeeMutation = {
  __typename?: "Mutation";
  deleteRecurringFee: { __typename?: "MutationResult"; success: boolean };
};

export const DeleteRecurringFeeDocument = gql`
  mutation deleteRecurringFee($email: String!) {
    deleteRecurringFee(email: $email) {
      success
    }
  }
`;
export type DeleteRecurringFeeMutationFn = Apollo.MutationFunction<
  DeleteRecurringFeeMutation,
  DeleteRecurringFeeMutationVariables
>;

/**
 * __useDeleteRecurringFeeMutation__
 *
 * To run a mutation, you first call `useDeleteRecurringFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecurringFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecurringFeeMutation, { data, loading, error }] = useDeleteRecurringFeeMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useDeleteRecurringFeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRecurringFeeMutation,
    DeleteRecurringFeeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteRecurringFeeMutation,
    DeleteRecurringFeeMutationVariables
  >(DeleteRecurringFeeDocument, options);
}
export type DeleteRecurringFeeMutationHookResult = ReturnType<
  typeof useDeleteRecurringFeeMutation
>;
export type DeleteRecurringFeeMutationResult =
  Apollo.MutationResult<DeleteRecurringFeeMutation>;
export type DeleteRecurringFeeMutationOptions = Apollo.BaseMutationOptions<
  DeleteRecurringFeeMutation,
  DeleteRecurringFeeMutationVariables
>;
